import editIcon from './../Assets/icons/Un-Checkbox.svg'
import deleteIcon from './../Assets/icons/trash.svg'

export const TABLE_HEADERS = [
   
   // "Manufacturer",
    "Business Partner",
    "Product",
    "Sub Product",
    "Make",
    "Model",
    "Variant",
    "Color",
    "Fuel",
    "Price",
    "Action"
  ];
  
  export const TABLE_DATA = [
    { manufacture_id: 1, manufacturer: "-", business_partner:"lorem ipsum", product:"car", sub_product: "Active", make:"Honda",model:"Activa6G",variant:"DLX",color:"Black",fuel_type:"Petrol",price:"10000", actions: "Edit/Delete" },
    { manufacture_id: 2, manufacturer: "-", business_Partner:"lorem ipsum", product:"car", sub_product: "Inactive",make:"Honda",model:"Activa6G",variant:"DLX",color:"Black",fuel_type:"Petrol",price:"10000", actions: "Edit/Delete" },
    { manufacture_id: 3, manufacturer: "-", business_Partner:"lorem ipsum", product:"car", sub_product: "Active",make:"Honda",model:"Activa6G",variant:"DLX",color:"Black",fuel_type:"Petrol",price:"10000", actions: "Edit/Delete" },
  ];
  
  export const keyMapping = {
   // "Sr No.": "manufacture_id",
    "Manufacturer": "manufacturer",
    "Business Partner":"bp_name",    
    "Product": "product_name",
    "Sub Product":"subproduct_name",
    "Make":"make_name",
    "Model":"model_name",
    "Variant":"variant_name",
    "Color":"color_name",
    "Fuel":"fuel_type_name",
    "Price":"purchase_price",
    "Action": [
        { type: "edit", icon: editIcon, label: "Edit" },
        // { type: "delete", icon: deleteIcon, label: "delete" },
        
      ]
  };